class UpsellProduct extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("#addUpsellButton");
    this.button.addEventListener("click", this.addUpsellVariantPicker.bind(this));
    this.injectUpsellVariantPickerHere = this.querySelector("#injectUpsellVariantPickerHere");
  }

  addUpsellVariantPicker() {
    var clone = document.querySelector("upsell-variant-picker").cloneNode(true);
    this.injectUpsellVariantPickerHere.appendChild(clone);
  }
}

customElements.define("upsell-product", UpsellProduct);

class UpsellVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.removeVariantPickerButton = this.querySelector(".upsell-product_remove-button");
    this.buttons = this.querySelectorAll(".button-variant");
    this.baseSubscriptionPrice = document.querySelector("[data-base-subscription-price]").dataset.baseSubscriptionPrice;
    this.baseProductPrice = document.querySelector("[data-base-product-price]").dataset.baseProductPrice;
    this.currencySymbol = document.querySelector("[data-current-currency]").dataset.currentCurrency;
    this.discountBreakpoint = document.querySelector("[data-discount-breakpoint]").dataset.discountBreakpoint;
    this.discountStep = document.querySelector("[data-discount-step]").dataset.discountStep;
    this.discountValue = document.querySelector("[data-discount-value]").dataset.discountValue;
    this.productUnitName = document.querySelector("[data-product-unit-name]").dataset.productUnitName;
    this.legendValue = this.querySelector('.upsell-product_legend-value')
    this.discountLabel = document.querySelector('.upsell-product_economie-label')
    this.discountLabelValue = document.querySelector('.upsell-product_economie-label-value')
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.removeVariantPickerButton.addEventListener("click", this.removeVariantPicker.bind(this));
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.selectVariant.bind(this));
    });
    document.querySelectorAll(".jc-planOption-input").forEach((planInput) => {
      planInput.addEventListener("click", this.injectInputIdsIntoAtcForm.bind(this));
    });

    document.querySelectorAll("input[name=subscription]").forEach((saleMethodRadio) => {
      saleMethodRadio.addEventListener("change", this.injectInputIdsIntoAtcForm.bind(this));
    });

    document.body.addEventListener("variantUpdateElements", () => {
      setTimeout(() => {
        this.injectInputIdsIntoAtcForm();
        this.updateMainWidgetPrices();
      }, 1);
    });

    document.querySelector('product-form .quantity__input').addEventListener("change", () => {
      this.updateMainWidgetPrices(document.querySelector('product-form .quantity__input').value)
    })

    document.addEventListener("upsellVariantChange", () => {
      const variantPickerElement = document.querySelector('variant-picker');
      if (variantPickerElement && variantPickerElement.elements) {
        const parsedVariantsJSON = JSON.parse(variantPickerElement.elements.variantsJSON.textContent);
        const checkedInputs = variantPickerElement.querySelectorAll(".js-variants-update:checked");
        const upsellVariantPickerElements = document.querySelector('#injectUpsellVariantPickerHere').querySelectorAll('upsell-variant-picker');
        var checkedOptions = Array.from(checkedInputs, (input) => input.value);
        upsellVariantPickerElements.forEach((element) => {
          checkedOptions.push(element.querySelector('.button-variant-selected').dataset.variantName);
        })
        var metafields = null;
        checkedOptions.some((option) => {
          var currentVariant = parsedVariantsJSON.find((variant) => variant.title === option);
          if (currentVariant && currentVariant.metafields && currentVariant.metafields.active) {
            metafields = currentVariant.metafields;
            return true;
          }
        });
        this.updateDateDelivery(metafields && metafields.active ? metafields : null);
        this.updatePreorderInput(metafields && metafields.active ? true : false, metafields);
        this.updateATCPreorder(metafields && metafields.active ? true : false);
      }
    })

    this.injectInputIdsIntoAtcForm();
    this.updateMainWidgetPrices();
    document.dispatchEvent(new Event('upsellVariantChange'));
  }

  updateMainWidgetPrices(quantity) {
    var currentQuantity = quantity || this.getCurrentProductPickedCount()
    var productPrice = currentQuantity * this.baseProductPrice
    var productCompareAtPrice = currentQuantity * this.baseProductPrice
    var subscripionPrice = currentQuantity * this.baseSubscriptionPrice

    if (currentQuantity >= this.discountBreakpoint) {
      var discountTotalValue = this.discountValue * Math.floor(currentQuantity / this.discountStep)
      productPrice = productPrice - discountTotalValue
      subscripionPrice = subscripionPrice - discountTotalValue
    }

    var subscripionPercentDiscount = 100 - (subscripionPrice * 100 / productCompareAtPrice)

    document.querySelector(".jc-onetime-input .js-update-price").innerHTML = this.formatPrice(productPrice);
    document.querySelectorAll('subscription-widget')[0].dataset.price = productPrice
    document.querySelectorAll('subscription-widget')[1].dataset.price = productPrice

    if (productPrice != productCompareAtPrice) {
      if(document.querySelector(".jc-onetime-input .js-onetime-compare-at-price")){
        document.querySelector(".jc-onetime-input .js-onetime-compare-at-price").innerHTML = this.formatPrice(productCompareAtPrice);
        document.querySelector(".jc-onetime-input .js-onetime-compare-at-price").style.display = "inline-block";
      }
    } else {
      if(document.querySelector(".jc-onetime-input .js-onetime-compare-at-price")){
        document.querySelector(".jc-onetime-input .js-onetime-compare-at-price").innerHTML = "";
        document.querySelector(".jc-onetime-input .js-onetime-compare-at-price").style.display = "none";
      }
    }

    document.querySelector(".jc-subscription-input .js-recharge-discount") 
      ? document.querySelector(".jc-subscription-input .js-recharge-discount").innerHTML = this.formatPercent(subscripionPercentDiscount)
      : null;

    document.querySelector(".jc-subscription-input .js-recharge-discount-test") 
      ? document.querySelector(".jc-subscription-input .js-recharge-discount-test").innerHTML = this.formatPercent(subscripionPercentDiscount)
      : null;
      
    if(document.querySelector(".jc-subscription-input .jc-line-through")){
      document.querySelector(".jc-subscription-input .jc-line-through").innerHTML = this.formatPrice(productCompareAtPrice)
      document.querySelectorAll('subscription-widget')[0].dataset.comparePrice = productCompareAtPrice
      document.querySelectorAll('subscription-widget')[1].dataset.comparePrice = productCompareAtPrice
    }

    if(document.querySelector(".jc-subscription-input .js-update-price")){
      document.querySelector(".jc-subscription-input .js-update-price").innerHTML = this.formatPrice(subscripionPrice)
      document.querySelectorAll('subscription-widget')[0].dataset.sellingPlanPrice = subscripionPrice
      document.querySelectorAll('subscription-widget')[1].dataset.sellingPlanPrice = subscripionPrice
    }

    document.querySelectorAll('.jc-subscripion-block input').forEach((input) => {
      if (input.checked) {
        if (input.nextElementSibling.querySelector('label') != null) {
          input.nextElementSibling.querySelector('label').click()
        }
      }
    })
    this.updateDiscountLabel(currentQuantity)
  }

  updateDiscountLabel(currentQuantity) {
    if (currentQuantity < (this.discountBreakpoint - 1)) {
      this.discountLabel.style.display = "none"
    } else {
      this.discountLabel.style.display = "block"
      this.discountLabelValue.innerHTML = this.formatPrice((currentQuantity + 1) / this.discountStep * this.discountValue)
    }
  }

  getCurrentProductPickedCount() {
    return document.querySelectorAll("#injectUpsellVariantPickerHere upsell-variant-picker").length + 1
  }

  formatPercent(unformatted_percent) {
    return Math.round((unformatted_percent * 10), 2) / 10 + "%";
  }

  formatPrice(unformatted_price) {
    unformatted_price = unformatted_price / 100;
    if (unformatted_price.toString().includes(".") == false) unformatted_price = unformatted_price + ",00";
    if (unformatted_price.toString().includes(".5")) unformatted_price = unformatted_price.toString().replace('.5', ',50');
    if (unformatted_price.toString().includes(".")) unformatted_price = unformatted_price.toString().replace('.', ',');
    return this.currencySymbol + unformatted_price;
  }

  selectVariant(event) {
    this.resetSelectedVariant();
    event.target.classList.add("button-variant-selected");
    this.legendValue.innerHTML = event.target.dataset.variantName
    this.injectInputIdsIntoAtcForm();
    document.dispatchEvent(new Event('upsellVariantChange'));
  }

  resetSelectedVariant() {
    this.buttons.forEach((button) => {
      button.classList.remove("button-variant-selected");
    });
  }

  injectInputIdsIntoAtcForm() {
    this.resetInputIdsIntoAtcForm();
    var upsellVariantIds = [];
    var upsellVariantData = [];

    document.querySelectorAll("#injectUpsellVariantPickerHere upsell-variant-picker").forEach((upsellVariantPicker) => {
      var selected = upsellVariantPicker.querySelector(".button-variant-selected");
      upsellVariantIds.push(selected.dataset.variantId);
      upsellVariantData.push({ "variantId": selected.dataset.variantId, "preorder": selected.dataset.variantPreorder, "cart_text": selected.dataset.variantCartText });
    });

    var occurrences = {};
    upsellVariantIds.forEach((upsellVariantId) => {
      occurrences[upsellVariantId] = (occurrences[upsellVariantId] || 0) + 1;
    });

    upsellVariantIds = upsellVariantIds.filter((upsellVariantId, index, self) => {
      return self.indexOf(upsellVariantId) === index;
    });

    upsellVariantIds.forEach((upsellVariantId, index) => {
      var sellingPlanInput = null;
      var data = upsellVariantData.find((item) => item.variantId === upsellVariantId);
      var quantity = occurrences[upsellVariantId];
      var content = ''

      document.querySelectorAll(".jc-planOption-input").forEach((sellingPlanOption) => {
        if (sellingPlanOption.checked) sellingPlanInput = sellingPlanOption;
      });

      if (document.querySelector('input[name="id"][value="' + upsellVariantId + '"]'))
        content = '<input class="upsellInput" type="hidden" name="quantity" value="' + (quantity + 1) + '">';
      else {
        content =
          '<input class="upsellInput" type="hidden" name="items[' + (index + 1) + '][id]" value="' + upsellVariantId + '">' +
          '<input class="upsellInput" type="hidden" name="items[' + (index + 1) + '][quantity]" value="' + quantity + '">' +
          '<input class="upsellInput" type="hidden" name="items[' + (index + 1) + '][selling_plan]" value="' + sellingPlanInput.value + '">';
        if (data.preorder)
          content += `<input class="upsellInput" type="hidden" name="items[${index + 1}][properties[Précommande]]" value="${data.cart_text}">`;
      }

      content += document.querySelector("#js-main-product-sticky-atc").innerHTML;
      document.querySelector("#js-main-product-sticky-atc").innerHTML = content;
    });
  }

  resetInputIdsIntoAtcForm() {
    document
      .querySelector("#js-main-product-sticky-atc")
      .querySelectorAll(".upsellInput")
      .forEach((input) => {
        input.remove();
        this.updateMainWidgetPrices();
      });
  }

  removeVariantPicker() {
    this.remove();
    this.injectInputIdsIntoAtcForm();
    this.resetDateDelivery();
    document.dispatchEvent(new Event('upsellVariantChange'));
  }

  updateDateDelivery(data) {
    const element = document.querySelector(".jc-delivery-fill-please");
    if(!element) return;
    const content = element.querySelector(".jc-delivery-date--text");
    const boutonModal = document.querySelector('button[data-modal="#modal_preorder"]');

    if (data) {
      if (content) {
        const clonedBoutonModal = boutonModal.cloneNode(true);
        const modal = document.querySelector('#modal_preorder');
        modal.querySelector('.jc-richtext').innerHTML = data.popup_content.replace(/\n/g, "<br>");
        element.classList.add("preorder");
        content.textContent = data.precision;
        clonedBoutonModal.classList.remove("hidden");
        if (element.querySelector("button")) {
          element.removeChild(element.querySelector("button"));
        }
        element.appendChild(clonedBoutonModal);
      } else {
        setTimeout(() => {
          this.updateDateDelivery(data);
        }, 100);
      }
    } else {
      element.classList.remove("preorder");
      element.innerHTML = document.querySelector(".delivery-date-snippet").innerHTML;
      element.classList.remove("hidden");
    }
  }

  updatePreorderInput(data, metafields) {
    const input = document.querySelector('input[name="properties[Précommande]"]');
    if (data) {
      if(input){
        input.value = metafields.cart_text;
      } else {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Précommande]';
        input.value = metafields.cart_text;
        // append the input next to the input who has name="id"
        document.querySelector('input[name="id"]').after(input);
      }
    } else {
      if(input){
        input.remove();
      }
    }
  }

  updateATCPreorder(preorder) {
    var buttons = document.querySelectorAll('button[js-add-to-cart-btn]');
    if (preorder) {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.add('hidden');
        button.querySelector("#altText").classList.remove('hidden')
      })
    } else {
      buttons.forEach((button) => {
        button.querySelector("#mainText").classList.remove('hidden');
        button.querySelector("#altText").classList.add('hidden')
      })
    }
  }

  resetDateDelivery() {
    const element = document.querySelector(".jc-delivery-fill-please");
    element.classList.remove("preorder");
    element.innerHTML = document.querySelector(".delivery-date-snippet").innerHTML;
    element.classList.remove("hidden");
  }
}

customElements.define("upsell-variant-picker", UpsellVariantPicker);
